<template>
	<div class="logon" id="logon">
		<div class="logon_header w1200 flex">
			<router-link to="/" class="logon_header_logo"><img :src="public.top_logo" class="block" /></router-link>
			<div class="logon_header_r tc f16px">
				<router-link to="/" class="logon_header_list cl_dark">
					<img src="../../static/icon_index.png" />
					<p>返回首页</p>
				</router-link>
				<router-link to="/logon" class="logon_header_list cl_dark">
					<img src="../../static/icon_logon.png" />
					<p>注册</p>
				</router-link>
				<router-link to="/" class="logon_header_list cl_dark">
					<img src="../../static/icon_sign.png" />
					<p>直接登录</p>
				</router-link>
			</div>
		</div>
		<div class="forget_cont bg_gray">
			<div class="w1200">
				<div class="forget" v-if="forget_step == 1">
					<div class="forget_title tc f36px">忘记密码</div>
					<div class="logon_item mat80">
						<input type="text" v-model="mobile" placeholder="输入手机号" class="logon_item_input f16px" />
					</div>
					<div class="logon_item f16px">
						<div class="logon_item_hide">
							<input type="text" v-model="code" placeholder="输入验证码" class="logon_item_input f16px" />
							<button type="button" class="cl_violet logon_send" @click="send" :disabled="!sendTrue">{{sendText}}</button>
						</div>
					</div>
					<div class="phone_next cur tc f18px cl_white" @click="next">下一步</div>
				</div>
				<div class="forget_set" v-if="forget_step == 2">
					<div class="forget_title tc f36px">重置密码</div>
					<div class="logon_item mat80">
						<input type="password" v-model="password" placeholder="输入新密码" class="logon_item_input f16px" />
					</div>
					<div class="logon_item mat30">
						<input type="password" v-model="password_two" placeholder="再次输入新密码" class="logon_item_input f16px" />
					</div>
					<div class="phone_next cur tc f18px cl_white" @click="nextTwo">下一步</div>
				</div>
				<div class="forget_success tc" v-if="forget_step == 3">
					<img src="../../static/success_violet.png" />
					<p class="f30px mat20">您的密码已重置成功！</p>
					<router-link to="/" class="f18px cl_white forget_return block mat80">返回首页</router-link>
					<p class="cl_gray mat10"><span class="cl_violet">{{return_time}}</span> 后系统自动跳转到首页</p>
				</div>
				<div class="tc cl_violet">
					<div class="logon_footer_top f36px">
						<img src="../../static/phone_violet.png" />
						<span>{{public.web_phone}}</span>
					</div>
					<div class="logon_footer_btm mat10">
						<p>{{public.web_copyright}} | <a href="http://www.beian.gov.cn" target="_blank" class="cl_violet">{{public.web_record}}</a></p>
						<p class="mat5">{{public.company_name}}</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'forget',
		components: {
		 
		},
		props: {
	
		},
		data () {
			return {
				forget_step: 1, //步骤
				mobile: "", //手机号
				code: "",//验证码
				timer: 60,//倒计时
				sendText: "发送验证码",
				sendTrue: true,
				password: "",
				password_two: "",
				return_time: 5,
				public: {},
			}
		},
		created() {
			
		},
		mounted() {
			this.getInfo();
		},
		methods: {
			getInfo () {
				var that = this;
				that.$get("/api/base/get_base_configuration_data",{})
				.then(res => {
					that.public = res.data;
				});
			},
			//验证码倒计时
			send() {
				var that = this;
				that.$get("/api/login/send_sms_captcha",{
					phone: that.mobile,
					type: 3,
				})
				.then(res => {
					that.sendTrue = false;
					let auth_timer = setInterval(()=>{
						that.timer--;
						that.sendText = that.timer + "s后重试"
						if(that.timer<=0){
							that.sendTrue = true;
							that.sendText = "发送验证码";
							that.timer = 60;
							clearInterval(auth_timer);
						}
					},1000)
				});
			},
			//下一步
			next () {
				var reg =  /^1[0-9]{10}$/;
				if (!reg.test(this.mobile)) {
					this.$message({
						duration: 1500,
						message: "手机号码格式错误",
						type: 'warning'
					});
					return false
				}
				this.forget_step = 2;
			},
			nextTwo () {
				var that = this;
				if (that.password != that.password_two) {
					this.$message({
						duration: 1500,
						message: "密码不一致",
						type: 'warning'
					});
					return false
				}
				this.$get("/api/user/post_reset_passwords",{
					phone: this.mobile,
					code: this.code,
					new_pwd: this.password,
				})
				.then(res => {
					this.$message({
						duration: 2000,
						message: res.msg,
						type: 'success'
					});
					that.forget_step = 3;
					let return_timer = setInterval(()=>{
						that.return_time--;
						if(that.return_time<=0){
							clearInterval(return_timer);
							this.$router.push({path: '/',});
						}
					},1000)
				});
			},
		},
	}
</script>

<style>
</style>
